<template>
  <v-dialog
    v-model="dialogVisible"
    persistent
    maxWidth="700px"
  >
    <v-card>
      <v-card-title class="modal-header">
        <v-icon
          size="24"
          color="#26384B"
          class="mr-2"
        >
          mdi-lock
        </v-icon>
        <span>{{ $t('forms.labels.lockInUseTitle') }}</span>
      </v-card-title>
      <v-card-text class="content">
        <p>
          {{ $t('forms.labels.lockInUse') }}
        </p>
      </v-card-text>
      <v-card-actions class="error-buttons">
        <v-spacer />
        <v-btn
          color="primary"
          class="capitalize large"
          @click="cancel"
        >
          {{ $t('forms.labels.lockInUseLeaveQueue') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { getSocketClient } from '@/utilities/socket';
import EventBus from '@/utilities/event-bus';

export default {
    name: 'LockQueueModal',
    data() {
        return {
            dialogVisible: false,
            componentId: null,
            retrieveLock: null,
            retryFunction: null,
        };
    },
    created() {
        EventBus.$on('open-lock-queue-modal', this.openModal);
    },
    mounted() {
        const socket = getSocketClient();
        if (socket) {
            socket.on('LOCK_BROADCAST_RELEASED', this.onLockReleased);
        }
    },
    beforeDestroy() {
        const socket = getSocketClient();
        if (socket) {
            socket.off('LOCK_BROADCAST_RELEASED', this.onLockReleased);
        }
        EventBus.$off('open-lock-queue-modal', this.openModal);
    },
    methods: {
        openModal(data) {
            this.componentId = data.componentId;
            this.retrieveLock = data.retrieveLock;
            this.retryFunction = data.retryFunction;
            this.dialogVisible = true;
        },
        async onLockReleased(payload) {
            if (payload.componentId === this.componentId && this.retrieveLock) {
                try {
                    const acquired = await this.retrieveLock();
                    if (acquired) {
                        this.dialogVisible = false;
                        this.retryFunction();
                        this.resetModal();
                    }
                } catch (error) {
                    console.error('Error retrying lock:', error);
                }
            }
        },
        cancel() {
            this.dialogVisible = false;
            this.resetModal();
        },
        resetModal() {
            this.componentId = null;
            this.retrieveLock = null;
            this.retryFunction = null;
        },
    },
};
</script>

<style scoped lang="scss">
.modal-header {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #26384B;
  border-bottom: 1px solid rgba(169, 169, 169, 1);
  padding-bottom: 10px;
}
.content p {
  color: #26384B;
  font-size: 14px;
  text-align: center;
}
.error-buttons {
  padding: 10px;
}
.capitalize {
  text-transform: capitalize;
}
.large {
  min-width: 150px;
}
.mr-2 {
  margin-right: 8px;
}
</style>
